import React from 'react';
import styles from './AddQuestionMenu.module.css';
import { QUESTION_CONFIG } from '../questionTypes';
import { FiX } from 'react-icons/fi';
import {FormattedMessage} from "react-intl";

const AddQuestionMenu = ({ isOpen, onClose, onSelectQuestionType }) => {
    if (!isOpen) {
        return null;
    }

    const handleSelect = (type) => {
        onSelectQuestionType(type);
        onClose(); // Закрываем меню после выбора
    };

    return (
        <>
            <div className={styles.backdrop} onClick={onClose}></div>
            <div className={styles.menuPanel}>
                <div className={styles.menuHeader}>
                    <h3><FormattedMessage id="addQuestionMenu.title" /></h3>
                    <button onClick={onClose} className={styles.closeButton}>
                        <FiX />
                    </button>
                </div>
                <ul className={styles.menuList}>
                    {QUESTION_CONFIG.map(({ type, labelId, icon: Icon }) => (
                        <li key={type} className={styles.menuItem} onClick={() => handleSelect(type)}>
                            <Icon className={styles.menuIcon} />
                            <span><FormattedMessage id={labelId} /></span>
                        </li>
                    ))}
                </ul>
            </div>
        </>
    );
};

export default AddQuestionMenu;
